var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("SET_DUEDAYALARM"),
        visible: "",
        width: "480px",
        "close-on-click-modal": false,
        "append-to-body": "",
      },
      on: { close: _vm.onCancel },
    },
    [
      _c("div", { staticClass: "info-cls" }, [
        _c("i", { staticClass: "el-icon-warning-outline" }),
        _vm._v(_vm._s(_vm.$t("DUEDAY_WARNING"))),
      ]),
      _c(
        "el-form",
        { staticClass: "duedayAlarmForm", attrs: { "label-width": "110px" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("TIME_OPTION") } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.active,
                    callback: function ($$v) {
                      _vm.active = $$v
                    },
                    expression: "active",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(" " + _vm._s(_vm.$t("STATUS_DAY_UNTILDUE._4"))),
                  ]),
                  _c("el-radio", { attrs: { label: 0 } }, [
                    _vm._v(_vm._s(_vm.$t("STATUS_DAYS_OVERDUE._3"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._l(_vm.datalist[Number(_vm.active)], function (item, index) {
            return _c(
              "el-form-item",
              { key: index, attrs: { label: _vm.labelFuc(index) } },
              [
                _vm.active === 0
                  ? _c(
                      "el-input",
                      {
                        model: {
                          value: item.value,
                          callback: function ($$v) {
                            _vm.$set(item, "value", _vm._n($$v))
                          },
                          expression: "item.value",
                        },
                      },
                      [
                        _c("template", { slot: "prepend" }, [
                          _vm._v(_vm._s(_vm.$t("STATUS_DAYS_OVERDUE._1"))),
                        ]),
                        _c("template", { slot: "append" }, [
                          _vm._v(_vm._s(_vm.$t("COMMON_DAY"))),
                        ]),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.active === 1
                  ? _c(
                      "el-input",
                      {
                        model: {
                          value: item.value,
                          callback: function ($$v) {
                            _vm.$set(item, "value", _vm._n($$v))
                          },
                          expression: "item.value",
                        },
                      },
                      [
                        _vm.$t("STATUS_DAY_UNTILDUE._1") != ""
                          ? _c("template", { slot: "prepend" }, [
                              _vm._v(_vm._s(_vm.$t("STATUS_DAY_UNTILDUE._1"))),
                            ])
                          : _vm._e(),
                        _c("template", { slot: "append" }, [
                          _vm._v(_vm._s(_vm.$t("STATUS_DAY_UNTILDUE._5"))),
                        ]),
                      ],
                      2
                    )
                  : _vm._e(),
              ],
              1
            )
          }),
        ],
        2
      ),
      _c(
        "el-button",
        {
          staticClass: "wl-green confirmBut",
          attrs: { type: "primary", loading: _vm.saveLoading },
          on: {
            click: function ($event) {
              return _vm.onConfirm()
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("btn_save")))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }